import PropTypes from 'prop-types'
import React from 'react'
import FieldsSeparator from '../../atoms/FieldsSeparator'
import clsx from 'clsx'
import { ReactSVG } from 'react-svg'
import infoIcon from '../../../images/icons/info.svg'

const InformationBlockCitizenField = ({ payload, position, className = 'mb-8' }) => {
  return (
    <div>
      {position > 0 ? <FieldsSeparator /> : ''}
      <div
        className={clsx('flex items-start px-6 py-6 pr-12 rounded-lg border-2 border-blue-900 bg-blue-300', className)}
      >
        <div className="flex items-start">
          <ReactSVG src={infoIcon} className="w-5 h-5 text-blue-400" />
          <div className="ml-3">
            <h3 className="text-base text-gray-800 font-bold">{payload?.label}</h3>
            <div
              className="mt-2 text-base text-gray-800 leading-6 hint-html-injected"
              dangerouslySetInnerHTML={{ __html: payload?.hint }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default InformationBlockCitizenField

InformationBlockCitizenField.propTypes = {
  className: PropTypes.string,
  payload: PropTypes.object,
  position: PropTypes.number
}
